'use client'

import { useEffect } from 'react'

/**
 * Cyan ring that expands and fades where the visitor clicks. Pure CSS animation on a throwaway
 * element (no per-move work), so it complements the native cursor without any lag.
 */
export default function ClickRipple() {
  useEffect(() => {
    if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return

    const onDown = (e: PointerEvent) => {
      const ring = document.createElement('span')
      ring.className = 'click-ripple'
      ring.style.left = `${e.clientX}px`
      ring.style.top = `${e.clientY}px`
      ring.addEventListener('animationend', () => ring.remove(), { once: true })
      document.body.appendChild(ring)
    }

    window.addEventListener('pointerdown', onDown, { passive: true })
    return () => window.removeEventListener('pointerdown', onDown)
  }, [])

  return null
}
